import React, { useEffect } from "react";
import { useDrop } from "react-dnd";
import PropTypes from "prop-types";
import { useParticipantLayoutActionAvailability } from "./participant-layout/participant-layout-action-availability";

const ItemTypes = {
  ASSET: "asset"
};

const handleDrop = (items, scene, userName, sessionId) => {
  const entries = items.map((item, index) => {
    const entry = {
      ...item,
      type: "media",
      url: item.url,
      thumbnail: item.thumbnail,
      index
    };
    // Preserve assetSrc if present (from drag & drop of "files" tab assets)
    if (item.assetSrc) {
      entry.assetSrc = item.assetSrc;
    }
    if (item.mediaOptions) {
      entry.mediaOptions = item.mediaOptions;
    }
    return entry;
  });

  entries.forEach(entry => {
    scene.emit("action_selected_media_result_entry", {
      entry,
      selectAction: "spawn"
    });
  });

  setTimeout(() => {
    window.APP.messageDispatch.push(
      {
        sender: userName,
        senderSessionId: sessionId
      },
      "object"
    );
  }, 1000);
};

const DropArea = ({ scene, userName, sessionId }) => {
  const [isDragging, setIsDragging] = React.useState(false);
  const { canDropFilesToScene } = useParticipantLayoutActionAvailability();

  const [{ isOver, canDrop }, drop] = useDrop({
    accept: ItemTypes.ASSET,
    canDrop: () => canDropFilesToScene,
    drop: item => {
      if (!canDropFilesToScene) {
        return;
      }

      const droppedItems = item.selectedItems;
      // Dummy function on drop
      handleDrop(droppedItems, scene, userName, sessionId);
    },
    collect: monitor => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop()
    })
  });

  useEffect(() => {
    const handleDragStart = () => {
      if (!canDropFilesToScene) {
        return;
      }

      setIsDragging(true);
    };

    const handleDragEnd = () => {
      setTimeout(() => {
        setIsDragging(false);
      }, 100);
    };

    window.addEventListener("dragstart", handleDragStart);
    window.addEventListener("dragend", handleDragEnd);

    return () => {
      window.removeEventListener("dragstart", handleDragStart);
      window.removeEventListener("dragend", handleDragEnd);
    };
  }, [canDropFilesToScene]);

  useEffect(() => {
    if (!canDropFilesToScene) {
      setIsDragging(false);
    }
  }, [canDropFilesToScene]);

  const isActive = isOver && canDrop;
  const backgroundColor = isActive ? "var(--color-brand-subtle)" : "transparent";

  if (!canDropFilesToScene || !isDragging) {
    return null;
  }

  return (
    <div
      ref={drop}
      id="droparea"
      style={{
        height: "100vh",
        flex: 1,
        border: "2px dashed var(--primary-color)",
        backgroundColor,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}
    ></div>
  );
};

DropArea.propTypes = {
  scene: PropTypes.object.isRequired,
  userName: PropTypes.string,
  sessionId: PropTypes.string
};

export default DropArea;
